export default {
  actions: {
    submit: 'Submit',
    add_guest: 'Add guest'
  },
  title: {
    main: 'Create booking',
    unauthorized: 'Expired session'
  },
  message: {
    complete_main: 'Process complete. You can close this window.'
  },
  fields: {
    facility: 'Facility',
    checkout: 'Checkout',
    name: 'Name',
    last_name: 'Last name',
    guests: 'Guests',
    identifier: 'Identifier'
  },
  error: {
    unauthorized: 'It seems like your active session has expired. Please go back to the administration panel and sign in again.'
  }
}
